import React from "react";
import PropTypes from "prop-types";
import { DELAYED_DELIVERY_TYPES } from "../scheduleBuilder";

export const DELIVERY_OPTIONS = [
  {
    value: "immediate_email",
    name: "Immediate PDF Delivery",
    description: "Upon purchase the fan will receive tickets as a PDF.",
  },
  {
    value: "immediate_electronic",
    name: "Immediate Electronic Delivery",
    description: "Upon purchase the fan will receive a link to add tickets to their digital wallet.",
  },
  {
    value: "delayed_email",
    name: "Delayed PDF Delivery",
    description: "At a date you determine the fan will receive an email with tickets attached as a PDF.",
  },
  {
    value: "delayed_electronic",
    name: "Delayed Electronic Delivery",
    description: "At a date you determine the fan will receive a link to add tickets to their digital wallet.",
  },
];

const DELIVERY_TIME_UNITS = ["hours", "days", "weeks", "months"];

const DeliveryTab = ({ settings, onChange }) => {
  const delayed = DELAYED_DELIVERY_TYPES.includes(settings.deliveryType);

  return (
    <div className="series-tab-panel">
      <p className="series-edit-hint">Choose how guests receive their tickets on every date of this show type.</p>

      <div className="series-mode-grid" role="radiogroup" aria-label="Delivery method">
        {DELIVERY_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={settings.deliveryType === option.value}
            className={["series-mode-option", settings.deliveryType === option.value ? "selected" : ""]
              .join(" ")
              .trim()}
            onClick={() => onChange({ deliveryType: option.value })}
          >
            <span className="series-mode-option-head">
              <span className="series-mode-radio" aria-hidden="true" />
              <span className="series-mode-option-label">{option.name}</span>
            </span>
            <span className="series-mode-option-description">{option.description}</span>
          </button>
        ))}
      </div>

      {delayed && (
        <section className="series-tab-section">
          <span className="series-edit-label">Deliver tickets</span>
          <div className="series-tab-inline">
            <input
              type="number"
              min="1"
              aria-label="Delivery time interval"
              className="series-edit-input series-tab-narrow-input"
              value={settings.deliveryTimeInterval}
              onChange={(event) => onChange({ deliveryTimeInterval: event.target.value })}
            />
            <select
              aria-label="Delivery time unit"
              className="series-edit-input series-tab-narrow-input"
              value={settings.deliveryTimeUnit}
              onChange={(event) => onChange({ deliveryTimeUnit: event.target.value })}
            >
              {DELIVERY_TIME_UNITS.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
            <span className="series-edit-hint">before each show starts</span>
          </div>
        </section>
      )}
    </div>
  );
};

DeliveryTab.propTypes = {
  settings: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DeliveryTab;
